import { Deserializable } from '../deserializable';
import { BrokerUser } from './broker-user';
import { UserRole } from './user-role';
export class Users implements Deserializable {
    id: number;
    email: string;
    mobile: string;
    imei: string;
    active: boolean;
    isoCountryCode: string;
    createdDate: string;
    updatedDate: string;
    userRoles: UserRole[] = [];
    brokerUsers: BrokerUser[] =[];

    deserialize(input: any): this {
        Object.assign(this, input);
        return this;
    }
}
